export const addNumbers = (array: Array<number>) => {
  if (!array || !array.length || !Array.isArray(array)) {
    return 0;
  }
  return array.reduce((tot, current) => {
    tot = +tot;
    current = isNaN(current) ? 0 : +current;
    return (tot += current);
  });
};

export const maxValue = (array: Array<number>) => {
  if (!array || !array.length || !Array.isArray(array)) {
    return 0;
  }
  array = array.map(x => (isNaN(x) ? 0 : x));
  return Math.max(...array);
};

export const minValue = (array: Array<number>) => {
  if (!array || !array.length || !Array.isArray(array)) {
    return 0;
  }
  array = array.map(x => (isNaN(x) ? 0 : x));
  return Math.min(...array);
};

export const getPercentage = (number: number, total = 100, precision = 2) => {
  if (!number) {
    return 0;
  }
  return roundPrecision((number / total) * 100, precision);
};

export const absolute = (number: number) => {
  if (!number || isNaN(number)) {
    return 0;
  }
  return Math.abs(number);
};

export const roundNumber = (number: number) => {
  if (!number || isNaN(number)) {
    return 0;
  }
  return Math.round(number);
};

export const roundPrecision = (number: number, precision: number) => {
  if (!number || isNaN(number)) {
    return 0;
  }
  const multiplier = Math.pow(10, precision || 0);
  return Math.round(number * multiplier) / multiplier;
};
